import { combineReducers } from 'redux'
import * as TypeAction from './actionTypes'
import { TypeSucesso, TypeErro } from 'scorpion-core';

const reducerAppBar = (typeBaseSalvar) => (state = { loading: true, obj: null }, action) => {

    switch (action.type) {
        case typeBaseSalvar:
            return { ...state, crudloading: true, crudError: '', crudMensagem: '', obj: null };
        case TypeSucesso(typeBaseSalvar):
            return { ...state, crudloading: false, crudMensagem: 'Sucesso!', obj: action.payload, };
        case TypeErro(typeBaseSalvar):
            return { ...state, crudloading: false, crudError: action.payload, obj: null };
        default:
            return state
    }

}
export default combineReducers({
    rAppBar: reducerAppBar(TypeAction.APPBAR),

})


// WEBPACK FOOTER //
// ./src/App/reducer.js